import React, { useCallback, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Navigation, Pagination } from "swiper";

import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { imageUrlCheck } from "../../../../utils/utils";
import { useNavigate } from "react-router-dom";
import LoadingBanner from "./LoadingBanner";
import SwiperItem from "./SwiperItem";
import { useSelector } from "react-redux";

const RedeemBanner = ({ data }) => {
    const navigate = useNavigate()
    const swiperRef = useRef(null);
    const [loading,setLoading] = useState(true)
    const isBannerLoaded = useSelector((state)=>state?.bannerLoading?.value)
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const pubid = projectInfo?.projectConfig?.pubid;
    const template = projectInfo?.projectConfig?.config?.TEMPLATE;
    const isRTL = useSelector((state) => state?.rtl?.isRTL);
    const kids = template === 'TEMPLATE_12';

    const syncKidsSwiper = useCallback(() => {
      if (!kids || typeof window === "undefined") {
        return;
      }

      const swiper = swiperRef.current;
      if (!swiper || swiper.destroyed) {
        return;
      }

      requestAnimationFrame(() => {
        if (!swiper || swiper.destroyed) {
          return;
        }

        swiper.updateSize();
        swiper.updateSlides();
        swiper.update();

        if (typeof swiper.updateAutoHeight === "function") {
          swiper.updateAutoHeight(0);
        }

        if (swiper.navigation && typeof swiper.navigation.update === "function") {
          swiper.navigation.update();
        }
      });
    }, [kids]);

    useEffect(()=>{
        if(!data){
          setLoading(true)
        }else{
          setLoading(false)
        }
       
    },[data])

    useEffect(() => {
      if (!kids) {
        return;
      }

      syncKidsSwiper();
      const timerId = setTimeout(syncKidsSwiper, 150);

      return () => clearTimeout(timerId);
    }, [kids, data, isBannerLoaded, syncKidsSwiper]);

    useEffect(() => {
      if (!kids || typeof window === "undefined") {
        return;
      }

      const handleResize = () => {
        syncKidsSwiper();
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [kids, syncKidsSwiper]);
   
  return (
    <div className={`featuredBannerType2 ${isRTL ? "rtl" : ""} ${template === "TEMPLATE_10" ? "gaia" : ""} ${kids ? "kids" : ""}`} role="region" aria-label="Featured Redeem Banners"> 
      {
        !isBannerLoaded&&
      <div className="loading">
        <LoadingBanner minHeight={"600px"}/>
      </div>
      }
      <Swiper
        slidesPerView={1}
        watchSlidesProgress
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          syncKidsSwiper();
        }}
        effect={"fade"}
        fadeEffect={kids ? { crossFade: true } : {}}
        spaceBetween={0}
        loop={true}
        navigation ={true}
        autoHeight={kids}
        observer={kids}
        observeParents={kids}
        autoplay={{
          delay: kids ? 6000 : 4000,
          disableOnInteraction: false,
        }}
        pagination={kids ? { clickable: true } : false}
        className="mySwiper"
        modules={kids ? [EffectFade, Autoplay, Navigation, Pagination] : [EffectFade, Autoplay, Navigation]}
        // allowSlideNext={false}
        // allowSlidePrev={false}
        aria-label="Redeem Banner Carousel"
      >
        {data?.shows?.map((item, index) => (
          <SwiperSlide key={index} aria-label={`Banner Slide ${index + 1}`}> 
              <SwiperItem data={item}/>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default  RedeemBanner;
